import { AtlasRoute } from "PFCore/utilities/routes";

import { ConversationId } from "../types";

export const buildChatWsEndpoint = (conversationId: ConversationId): string =>
  AtlasRoute(`/api/v1/agent/ws/chat/${conversationId}`);
